import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Music2, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { user, refreshUser } = useAuth();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMsg("Lien invalide."); return; }
    api.post("/auth/verify-email", { token })
      .then(async () => {
        setStatus("ok");
        if (localStorage.getItem("ilm_token")) { try { await refreshUser(); } catch {} }
      })
      .catch((e) => { setStatus("error"); setMsg(formatApiError(e.response?.data?.detail)); });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-violet-600/20 rounded-full blur-3xl" />
      <div className="w-full max-w-md relative text-center animate-fade-up">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-600 to-purple-700 flex items-center justify-center glow-violet"><Music2 size={22} /></div>
          <span className="font-display font-extrabold text-xl">ilove<span className="gradient-text">muzik</span></span>
        </Link>
        <div className="bg-[#0B0716] border border-zinc-800 rounded-3xl p-8" data-testid="verify-email-card">
          {status === "loading" && <Loader2 size={40} className="animate-spin text-violet-400 mx-auto" />}
          {status === "ok" && (
            <>
              <div className="w-16 h-16 rounded-full bg-emerald-500/15 flex items-center justify-center mx-auto mb-4"><CheckCircle2 size={30} className="text-emerald-400" /></div>
              <h1 className="text-2xl font-display font-bold mb-2">Email confirmé ✅</h1>
              <p className="text-sm text-zinc-400 mb-6">Ton compte est activé. Tu peux maintenant publier et proposer sur ilovemuzik.</p>
              <button onClick={() => nav(user ? "/app" : "/login")} data-testid="verify-continue-button" className="w-full py-3 rounded-xl bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-500 hover:to-purple-500 font-semibold transition-all">Continuer</button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="w-16 h-16 rounded-full bg-red-500/15 flex items-center justify-center mx-auto mb-4"><XCircle size={30} className="text-red-400" /></div>
              <h1 className="text-2xl font-display font-bold mb-2">Vérification échouée</h1>
              <p className="text-sm text-zinc-400 mb-6">{msg || "Le lien est invalide ou expiré."}</p>
              <button onClick={() => nav(user ? "/app" : "/login")} className="w-full py-3 rounded-xl bg-zinc-800 hover:bg-zinc-700 font-semibold transition-all">Retour</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
